// Best-effort clipboard helper for "copy embed snippet" buttons.
// Falls back to a hidden textarea + execCommand for older browsers / tests.

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through
    }
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

const WIDGET_PUBLIC_URL =
  (import.meta.env.VITE_WIDGET_PUBLIC_URL as string | undefined) ??
  "https://widget.chat.yai.nz/widget.js";

export function buildEmbedSnippet(input: {
  tenant: string;
  site: string;
  chatbot: string;
}): string {
  return `<script async src="${WIDGET_PUBLIC_URL}" data-tenant="${input.tenant}" data-site="${input.site}" data-chatbot="${input.chatbot}"></script>`;
}
